export default __webpack_public_path__ + "cdb21c27343bd39274a3ab0c969e8d57.png";